// extracted by mini-css-extract-plugin
module.exports = {"textPage":"Privacy_textPage__2id02","textContent":"Privacy_textContent__3R2wC"};